var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ContentHeader'),_c('div',{staticClass:"content-container"},[_c('FavItemList',{attrs:{"item-type":"menu"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }